import styled from 'styled-components';
import { Modal } from 'lib/components/Modal/Modal';

export const StyledDeleteMachineAttachmentModal = styled(Modal)`
  .ant-modal-body {
    padding: 24px 0;
  }
`;
